import React from 'react'
import PropTypes from 'prop-types'
import { toKebabCase } from 'utils/stringHelpers'
import { StyledDropdownMenu } from '../component.styles'

export const EditCourseMenu = ({
  courseInstanceName,
  forwardedRef,
  handleDeleteSubmit,
  handleEditSubmit,
  instance,
  isClassCardMenu,
}) => (
  <StyledDropdownMenu
    courseInstanceName={courseInstanceName}
    dataTestId={`dropdown-menu-button-${toKebabCase(courseInstanceName)}`}
    handleDeleteSubmit={handleDeleteSubmit}
    handleEditSubmit={handleEditSubmit}
    instance={instance}
    isClassCardMenu={isClassCardMenu}
    ref={forwardedRef}
  />
)

EditCourseMenu.propTypes = {
  courseInstanceName: PropTypes.string,
  forwardedRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  handleDeleteSubmit: PropTypes.func.isRequired,
  handleEditSubmit: PropTypes.func.isRequired,
  instance: PropTypes.object,
  isClassCardMenu: PropTypes.bool,
}
